<h1 mat-dialog-title i18n="School Details|School Details modal title@@school-details-modal-title">School Details</h1>
<div mat-dialog-content #dialogContent class="full-width">
  <permission-checker [roles]="roles">
    <div>
      <form [formGroup]="schoolForm" class="school-form">
        <form-input [control]="nameField"
                    label="School name"
                    i18n-label="School details|School name@@school-details-name-label"
                    placeholder="School name..."
                    i18n-placeholder="School details|School name placeholder@@school-details-name-placeholder"
                    [minLength]="5" [maxLength]="256"></form-input>
        <form-input [control]="shortNameField"
                    [required]="false"
                    label="School short name"
                    i18n-label="School details|School short name@@school-details-short-name-label"
                    placeholder="School short name..."
                    i18n-placeholder="School details|School short name placeholder@@school-details-short-name-placeholder"
                    [minLength]="5" [maxLength]="128"></form-input>

        <item-select [roles]="roles"
                     [disabled]="!!school?.id"
                     label="Select Region"
                     i18n-label="User Profile|School region select input label@@user-profile-school-region-select-input-label"
                     [compareWith]="compareRegions"
                     [displayWith]="displayRegion"
                     [loadWith]="loadRegions"
                     [selectedItem]="region"
                     (selected)="handleRegionSelected($event)"></item-select>

        <item-select [roles]="roles"
                     label="Select School Type"
                     i18n-label="User Profile|School type select input label@@user-profile-school-type-select-input-label"
                     [compareWith]="compareTypes"
                     [displayWith]="displayType"
                     [loadWith]="loadTypes"
                     [selectedItem]="type"
                     (selected)="typeSelected($event)"></item-select>

        <form-input [control]="addressField"
                    label="School address"
                    i18n-label="School details|School address@@school-details-address-label"
                    placeholder="School address..."
                    i18n-placeholder="School details|School address placeholder@@school-details-address-placeholder"
                    [minLength]="5" [maxLength]="128"></form-input>

        <form-input [control]="emailField"
                    [required]="false"
                    label="School email"
                    i18n-label="School details|School email@@school-details-email-label"
                    placeholder="School address..."
                    i18n-placeholder="School details|School email placeholder@@school-details-email-placeholder"
                    autocomplete="email"
                    type="email"
                    [minLength]="5" [maxLength]="128"></form-input>
        <form-input [control]="phoneField"
                    [required]="false"
                    label="School phone"
                    i18n-label="School details|School phone@@school-details-phone-label"
                    placeholder="School phone..."
                    i18n-placeholder="School details|School phone placeholder@@school-details-phone-placeholder"
                    type="tel"
                    [minLength]="7" [maxLength]="15"></form-input>

        <form-input [control]="websiteField"
                    [required]="false"
                    label="School website"
                    i18n-label="School details|School website@@school-details-website-label"
                    placeholder="School website..."
                    i18n-placeholder="School details|School website placeholder@@school-details-website-placeholder"
                    [minLength]="5" [maxLength]="128"></form-input>

        <form-input [control]="contactField"
                    [required]="false"
                    label="School contact"
                    i18n-label="School details|School contact@@school-details-contact-label"
                    placeholder="School contact person..."
                    i18n-placeholder="School details|School contact placeholder@@school-details-contact-placeholder"
                    [minLength]="10" [maxLength]="128"></form-input>
      </form>
    </div>

  </permission-checker>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              [secondary]="true"
              (clicked)="closeModal()"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button label="Save"
              i18n-label="General|Save action label@@general-save-action-label"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"></app-button>
</div>
